module.exports = __webpack_public_path__ + "resources/img/ico-company-aboutteam-ifg-3@2x.3c50ad50.png";